angular.module('picmonicng').component('inviteStudents', {
  templateUrl: '/templates/app/components/invite-students/invite-students.html',
  bindings: {
    schoolClass: '<',
    close: '&',
  },
  controller: [
    'UserService',
    'Upload',
    '$http',
    'toaster',
    '$state',
    function (UserService, Upload, $http, toaster, $state) {
      var $ctrl = this;
      $ctrl.UserService = UserService;
      $ctrl.step = 0;
      $ctrl.from = UserService.user.first_name + ' ' + UserService.user.last_name;
      $ctrl.message =
        'You just received 2 free weeks of Picmonic and a 20% off discount! Check it out by clicking the link below.';
      atlasEvent('click', 'Invite Students');

      $ctrl.uploadFiles = function (file) {
        if (file) {
          $ctrl.loadingImport = true;
          file.upload = Upload.upload({
            url: '/api/v3/educator_data/verify_csv',
            data: { file: file },
          });

          file.upload
            .then(function (response) {
              $ctrl.data = response.data;
              $ctrl.step = 3;
              atlasEvent('click', 'Invite Students - Step 3');
            })
            .catch(function (e) {
              toaster.error('Sorry there was an error processing your file!');
            })
            .finally(function () {
              $ctrl.loadingImport = false;
            });
        }
      };

      $ctrl.submit = function () {
        $http
          .post('/api/v3/educator_data/invite', {
            students: $ctrl.data.data,
            from: $ctrl.from,
            message: $ctrl.message,
            school_class_id: $ctrl.schoolClass ? $ctrl.schoolClass.school_class_id : null,
          })
          .catch(function () {
            toaster.error('Sorry there was an error processing your file!');
          })
          .then(function (r) {
            toaster.success('Success! ' + $ctrl.data.data.length + ' students were invited');
            $state.reload();
          });
      };
    },
  ],
});
